import { l10n } from '@ott/l10n';

export const SATURDAY_INDEX = 6;
export const SUNDAY_INDEX = 0;
export const DAY_IN_WEEK = 7;

export const WEEKDAYS = [
  l10n('calendar.weekdaysShort.Sunday'),
  l10n('calendar.weekdaysShort.Monday'),
  l10n('calendar.weekdaysShort.Tuesday'),
  l10n('calendar.weekdaysShort.Wednesday'),
  l10n('calendar.weekdaysShort.Thursday'),
  l10n('calendar.weekdaysShort.Friday'),
  l10n('calendar.weekdaysShort.Saturday'),
].map((cur, idx) => ({ isWeekend: idx === SATURDAY_INDEX || idx === SUNDAY_INDEX, label: cur }));

//день который точно есть в каждом месяце в независимости с какого дня недели начинается месяц
export const ANY_MONTH_DAY = 8;

export const WEEKDAYS_HEIGHT = 48;
// доп смещение нужно если в предыдущем месяце были выбраны даты в последней неделе
export const MONTH_SCROLL_OFFSET = WEEKDAYS_HEIGHT + 8;
export const WEEK_SCROLL_OFFSET = 12;

export const MONTH_HEIGHT = 36;
export const ROBAST_COEF = 1.5; // todo check it

export const ANIMATION_TIME = 300;

export const DEFAULT_TIME = '12:00';
